export enum IdType {
    CC = "Cédula de ciudadanía",
    CE = "Cédula de extranjería",
    NIT = "NIT",
    TI = "Tarjeta de dentidad",
    PA = "Pasaporte",
    NUIP = "Número único de identificación personal",
    RC = "Registro civil"
}